import { render, staticRenderFns } from "./retailerPaymentComponent.vue?vue&type=template&id=08c51cf2&"
import script from "./retailerPaymentComponent.vue?vue&type=script&lang=js&"
export * from "./retailerPaymentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports